// extracted by mini-css-extract-plugin
export default {"paginationInfo":"PaginationTextInfo_paginationInfo__+Mbnq"};